import { CSSProperties } from "react";

export const StylePropsSelect : CSSProperties ={
    color: "white",
    backgroundColor: "#ff5800",
    border: "1px solid black",
    padding: "4px 4px"
}